import { MapStringTo } from "../../base-types";
import { IUploadSource } from "../../contracts/upload/upload-source";
import Guard from "../../guard";

export class UploadRequest {
    constructor(source: IUploadSource, configurationName: string, actionName: string) {
        Guard.notNull(source);
        Guard.stringNotNullOrEmpty(configurationName);
        Guard.stringNotNullOrEmpty(actionName);

        this.source = source;
        this.configurationName = configurationName;
        this.actionName = actionName;
    }

    source: IUploadSource;
    configurationName: string;
    configurationParameters?: MapStringTo<unknown>;
    actionName: string;
    actionParameters?: MapStringTo<unknown>;
}
